<template>
  <el-card
    id="GLACard"
    shadow="hover"
    class="clear-card mainCard detailsCard"
  >
    <div
      slot="header"
      class="clearfix title header defaultCursor"
    >
      <span>{{ $t('coach.leader.gla.gla360') }}</span>
    </div>
    <div
      v-if="leader && (leader.gla_uuid && leader.gla_uuid !== 'off_platform')"
      class="dataWrap"
    >
      <el-button
        class="clearBtn"
        type="default"
        round
        @click="goToGLA(leader.gla_uuid)"
      >
        {{ $t('common.view') }}
      </el-button>
    </div>
    <div
      v-else
      class="no-data"
    >
      {{ $t('coach.leader.gla.noData') }}
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'GLA',

  props: {
    leader: {
      type: Object,
      default: null,
    },
  },

  methods: {
    goToGLA(uuid) {
      window.open(`${process.env.VUE_APP_GLA_CLIENT}/dashboard/assessment/${uuid}`, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
  #GLACard {
    min-height: 154px;

    .dataWrap {
      display: flex;
      width: 100%;
      flex-wrap: wrap;
      justify-content: center;

      .clearBtn {
        padding: 10px 5px;
        min-width: 120px;
        background-color: transparent;
        color: var(--themeFontColor);
      }
    }

    .no-data {
      display: flex;
      height: 100%;
      justify-content: center;
      align-items: center;
      font-style: italic;
      color: #c4c4c4;
    }
  }
</style>

<style lang="scss">
  #GLACard {
    .el-card__body {
      height: calc(100% - 95px);
    }

    .el-card__header {
      text-align: center;
      font-weight: bold;
    }

    &.mobile {
      .el-card__header {
        border-bottom: none;
      }
    }
  }
</style>
